import axiosInstance from '../app/axios';

export const cartAPI = {
  getCart: async () => {
    const response = await axiosInstance.get('/cart');
    return response.data;
  },

  addItem: async (item) => {
    const response = await axiosInstance.post('/cart/items', item);
    return response.data;
  },

  updateItem: async (itemId, updates) => {
    const response = await axiosInstance.patch(`/cart/items/${itemId}`, updates);
    return response.data;
  },

  removeItem: async (itemId) => {
    const response = await axiosInstance.delete(`/cart/items/${itemId}`);
    return response.data;
  },
};

export default cartAPI;